import moment from 'moment';

import type { DateOfBirthType } from 'src/components/date-of-birth-input/types';

import { convertToDate } from '../convert-to-date';

// Momentjs months are 0 indexed
const september = 8;
const october = 9;

export const validateDateOfBirth = (dateOfBirth: DateOfBirthType) => {
    const cutoffDate = moment();

    if (cutoffDate.month() >= october) {
        cutoffDate.add(1, 'year');
    }

    cutoffDate.subtract(17, 'years').set('date', 1).set('month', september);

    const convertedDate = convertToDate(dateOfBirth);

    if (!convertedDate) {
        return false;
    }

    return moment(convertedDate).isSameOrBefore(cutoffDate);
};
